import React from 'react';
import PropTypes from 'prop-types';
import Form from 'react-jsonschema-form';
import { StyleSheet, css } from 'aphrodite';
import moment from 'moment';

import OurismanTravelTheme from '../../ourismanTravelTheme';

const DisplayFieldTemplate = ({ children }) => children;
DisplayFieldTemplate.propTypes = {
  children: PropTypes.node.isRequired,
};

const StringField = ({ schema: { title, format }, formData }) => {
  const data = format === 'date' ? moment(formData).format('MMM. D, YYYY') : formData;

  return (<div className={css(styles.field)}>
    <span className={css(styles.question)}>{title}</span>
    <span className={css(styles.answer)}>{data}</span>
  </div>);
};
StringField.propTypes = {
  schema: PropTypes.shape().isRequired,
  formData: PropTypes.string,
};
StringField.defaultProps = {
  formData: '',
};

const ArrayFieldTemplate = props => <div>
  {props.title}
  {props.items.map(item => <div key={item.index}>{item.children}</div>)}
</div>;
ArrayFieldTemplate.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.arrayOf().isRequired,
};

const BooleanField = ({ schema, formData }) => {
  const enumNames = schema.enumNames || ['yes', 'no'];
  return (<div className={css(styles.field)}>
    <span className={css(styles.question)}>{schema.title}</span>
    <span className={css(styles.answer)}>{formData ? enumNames[0] : enumNames[1]}</span>
  </div>);
};
BooleanField.propTypes = {
  schema: PropTypes.shape().isRequired,
  formData: PropTypes.bool.isRequired,
};

const ResponseDetail = ({ response }) => {
  const formProps = {
    schema: JSON.parse(response.savedSchema),
    uiSchema: JSON.parse(response.savedUiSchema),
    formData: JSON.parse(response.response),
  };
  formProps.uiSchema['ui:readonly'] = true;

  return (<div className={css(styles.container)}>
    <Form
      {...formProps}
      fields={{ StringField, BooleanField }}
      FieldTemplate={DisplayFieldTemplate}
      ArrayFieldTemplate={ArrayFieldTemplate}
    ><div /></Form>
  </div>);
};

ResponseDetail.propTypes = {
  response: PropTypes.shape({
    savedSchema: PropTypes.string.isRequired,
    savedUiSchema: PropTypes.string.isRequired,
    response: PropTypes.string.isRequired,
  }).isRequired,
};

export default ResponseDetail;

const styles = StyleSheet.create({
  container: {
    margin: 5,
  },
  question: {
    fontWeight: 'bold',
    width: '25%',
  },
  answer: {
    width: '75%',
    marginLeft: 5,
  },
  field: {
    display: 'flex',
    ':nth-child(odd)': {
      background: OurismanTravelTheme.palette.primary3Color,
    },
  },
});



// WEBPACK FOOTER //
// /src/components/Forms/ResponseDetail.js